import React from 'react'
import { useTranslation } from 'react-i18next'
import { Modal, Button } from "react-bootstrap"
import "../../css/BobbingIcon.css"
import "../../css/SMPLButton.css"
import QRCode from "qrcode.react"
import Participant from '../../library/Participant'

interface SwitchDeviceModalProps {
  show: boolean
  participant: Participant | null
  onHide: () => void
}

export default function SwitchDeviceModal({ show, participant, onHide }: SwitchDeviceModalProps) {
  const { t } = useTranslation()

  let url = new URL(window.location.href)

  if (participant !== null) {
    participant.toSearchParams().forEach(function (value, key) {
      url.searchParams.set(key, value)
    })
  }

  return (
    <Modal show={show} centered onHide={onHide}>
      <Modal.Body className="p-4">

        <QRCode
          value={url.toString()}
          fgColor={"#151515"}
          size={500}
          style={{ width: "320px", height: "auto", maxWidth: "100%", margin: "30px auto"}}
          // imageSettings={{
          //   src: QrImage,
          //   width: 100,
          //   height: 100,
          //   excavate: true
          // }}
        />

        <h1>{t("common.switchDevice")}</h1>
        <p>{t("switchDevice.text")}</p>

      </Modal.Body>
      <Modal.Footer>
        <Button variant="link" onClick={onHide}>{t("switchDevice.buttonTitle")}</Button>
      </Modal.Footer>
    </Modal>
  )
}
